<div class=" rounded-[20px] p-6">

    <!-- HEADER -->
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-xl font-semibold text-[#444A6D]">
            {{ 'GENERAL_VOUCHER.TITLE' | translate }}
        </h1>
    </div>

    <!-- TABLE -->
    <div class="  p-4">

        @if (voucherList.length > 0) {
        <app-table [columns]="voucherColumns" [data]="voucherList" [actions]="voucherActions" [enablePagination]="true"
            [pageSize]="12">>
        </app-table>
        }

        @if (voucherList.length === 0) {
        <div class="text-center p-10 text-gray-500">
            {{ 'GENERAL_VOUCHER.NO_VOUCHERS_FOUND' | translate }}
        </div>
        }

    </div>

</div>


<!-- ================= DETAIL POPUP ================= -->
@if (showDetailModal) {
<app-popup [(show)]="showDetailModal" title="GENERAL_VOUCHER.VOUCHER_DETAILS" width="w-full max-w-5xl" type="custom">

    <!-- HEADER INFO -->
    <div class="grid grid-cols-2 gap-4 mb-4 text-sm">

        <div>
            <p class="text-gray-500">{{ 'GENERAL_VOUCHER.VOUCHER_ID' | translate }}</p>
            <p class="font-semibold">{{ selectedVoucher.voucherId }}</p>
        </div>

        <div>
            <p class="text-gray-500">{{ 'COMMON.DATE' | translate }}</p>
            <p class="font-semibold">{{ selectedVoucher.date }}</p>
        </div>

        <div>
            <p class="text-gray-500">{{ 'COMMON.DESCRIPTION' | translate }}</p>
            <p class="font-semibold">{{ selectedVoucher.description }}</p>
        </div>

        <!-- <div>
            <p class="text-gray-500">Branch</p>
            <p class="font-semibold">{{ selectedVoucher.branch }}</p>
        </div> -->

    </div>

    <!-- DETAIL TABLE -->
    <app-table [columns]="detailColumns" [data]="voucherDetails">
    </app-table>

    <!-- TOTALS -->
    <div class="flex justify-end gap-10 mt-6 text-sm font-semibold">

        <div>
            {{ 'GENERAL_VOUCHER.DEBIT' | translate }}:
            <span class="text-green-600">
                {{ totalDebit | currency:'PKR ':'symbol':'1.0-0' }}
            </span>
        </div>

        <div>
            {{ 'GENERAL_VOUCHER.CREDIT' | translate }}:
            <span class="text-red-600">
                {{ totalCredit | currency:'PKR ':'symbol':'1.0-0' }}
            </span>
        </div>

    </div>

    <!-- FOOTER -->
    <div class="flex justify-end mt-6">
        <button class="bg-red-500 text-white px-4 py-2 rounded-lg" (click)="showDetailModal = false">
            {{ 'COMMON.CLOSE' | translate }}
        </button>
    </div>

</app-popup>
}